import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import { Typography, Spin, Card, Modal } from "antd";
import axios from "axios";
import { config } from "../../../../config";
import "./GaleriDesa.scss";
import PlayButton from "../../../../assets/images/youtubeVideo/play-button.png";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const { Title } = Typography;

const GaleriDesa = () => {
  const [galeriDesaCantik, setGaleri] = useState([]); // ganti Dokumentasi → galeriDesaCantik
  const [loading, setLoading] = useState(true);
  const sliderRef = useRef();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const openModal = (item) => {
    setSelectedItem(item);
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setSelectedItem(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const namaDomain = window.location.href;
        const res = await axios.get(
          `${config.BASE_URL}organization/findContentOrganization?namaDomain=${namaDomain}`
        );

        // ambil key "galeriDesaCantik" langsung
        const result = res.data?.data?.dokumentasiDesaCantik || [];

        // format agar tetap konsisten dipakai di slider
        const formatted = result.map((item) => {
          const path = item.file?.replace(/^\/+/, "");
          const fullUrl = path
            ? `${config.BASE_URL}getReferenceFile?pathFile=${item.file}`
            : null;

          return {
            keterangan: item.keterangan || "keterangan tidak tersedia",
            backgroundImage:
              fullUrl || "https://source.unsplash.com/800x400/?village",
            urlVideo: item.urlVideo || null,
            file: item.file || null,
          };
        });

        setGaleri(formatted);
      } catch (error) {
        console.error("Gagal ambil data Galeri:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px 0" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="desa-cantik-slider-wrapper">
      <div className="slider-header">
        <Title level={4} style={{ margin: 0 }}>
          Dokumentasi
        </Title>
        <div className="slider-arrows">
          <div
            className="arrow-button"
            onClick={() => sliderRef.current.slickPrev()}
          >
            <LeftOutlined />
          </div>
          <div
            className="arrow-button"
            onClick={() => sliderRef.current.slickNext()}
          >
            <RightOutlined />
          </div>
        </div>
      </div>

      <Slider ref={sliderRef} {...settings} className="desa-cantik-slider">
        {galeriDesaCantik.map((item, index) => (
          <div key={index}>
            <Card
              bordered={false}
              className="carousel-card"
              style={{
                backgroundImage: item.file
                  ? `url(${item.backgroundImage})`
                  : item.urlVideo
                  ? "url(https://img.youtube.com/vi/" +
                    (item.urlVideo.split("v=")[1]?.split("&")[0] ||
                      item.urlVideo) +
                    "/hqdefault.jpg)"
                  : "url(https://source.unsplash.com/800x400/?village)",
                cursor: "pointer",
              }}
              onClick={() => openModal(item)}
            >
              {" "}
              {item.urlVideo && (
                <div className="video-overlay">
                  <img src={PlayButton} alt="Play" className="play-icon" />
                </div>
              )}
            </Card>
          </div>
        ))}
      </Slider>

      <Modal
        open={isModalVisible}
        onCancel={closeModal}
        footer={null}
        width={1200}
        centered
        className="image-modal"
      >
        {selectedItem && (
          <div className="modal-content-wrapper">
            <div className="modal-image">
              {selectedItem.file ? (
                <img
                  src={selectedItem.backgroundImage}
                  alt="Preview"
                  style={{ width: "100%", borderRadius: 8 }}
                />
              ) : selectedItem.urlVideo ? (
                <iframe
                  width="100%"
                  height="500"
                  src={`https://www.youtube.com/embed/${
                    selectedItem.urlVideo.split("v=")[1]?.split("&")[0] ||
                    selectedItem.urlVideo
                  }`}
                  title="Video Preview"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ borderRadius: 8 }}
                />
              ) : (
                <p>Tidak ada media.</p>
              )}
            </div>
            <div className="modal-description">
              <p>{selectedItem.keterangan}</p>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default GaleriDesa;
